export const FETCH_ASSET_COMPANY = '@@assetCompany/fetch-assetCompany';
export const FETCH_ASSET_COMPANY_SUCCESS = '@@assetCompany/fetch-assetCompany-success';
export const FETCH_ASSET_COMPANY_FAILURE = '@@assetCompany/fetch-assetCompany-failure';
